module.exports = __webpack_public_path__ + "img/Mehrzweckponton.20dbdf0e.svg";